import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.resetScroll()
      })
  }

  private resetScroll(): void {
    const contentAreas = document.querySelectorAll('.content-area')
    contentAreas.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.style.scrollMarginTop = `100px`
        element.scrollIntoView({
          block: 'start'
        })
      }
    })
  }
}
